import { ListChecksIcon, UsersIcon, ClockIcon, ThumbsUpIcon } from 'lucide-react';

export const stats = [
  { icon: ListChecksIcon, value: '+240', label: 'Ejercicios detallados' },
  { icon: UsersIcon, value: '+6.000', label: 'Profesoras beneficiadas' },
  { icon: ClockIcon, value: '8.200+', label: 'Horas ahorradas' },
  { icon: ThumbsUpIcon, value: '99%', label: 'Lo recomiendo' }
];
